import Button from '@mui/material/Button';
import { closeSnackbar, type ProviderContext } from 'notistack';

/** A fresh user click opens DoseSpot after the patient connection request. */
export function notifyDoseSpotReady(
  enqueueSnackbar: ProviderContext['enqueueSnackbar'],
  href: string,
): void {
  enqueueSnackbar('Patient connected. Open DoseSpot to prescribe.', {
    variant: 'success',
    persist: true,
    preventDuplicate: true,
    action: key => (
      <>
        <Button color="inherit" size="small" href={href} target="_blank" rel="noopener noreferrer">
          Open DoseSpot
        </Button>
        <Button color="inherit" size="small" onClick={() => closeSnackbar(key)}>
          Dismiss
        </Button>
      </>
    ),
  });
}
